module.exports = __webpack_public_path__ + "static/implant-before-4665d191d95b38b485508fde030906f8.jpg";